import { Component, OnDestroy, OnInit, ViewEncapsulation, ElementRef, Input, AfterViewInit } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreConfigService } from '@core/services/config.service';
import { Router ,NavigationEnd} from '@angular/router';

@Component({
  selector: 'vertical-layout',
  templateUrl: './vertical-layout.component.html',
  styleUrls: ['./vertical-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VerticalLayoutComponent implements OnInit, OnDestroy {
  coreConfig: any;
  @Input()  isLoading: boolean;  
  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(private _coreConfigService: CoreConfigService, private _elementRef: ElementRef,private router: Router) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const body = document.body;
        body.className = ''; // Clear existing route-based classes
        if (event.urlAfterRedirects.includes('dashboard')) {
          body.classList.add('dashboard-theme');
        } else if (event.urlAfterRedirects.includes('login')) {
          body.classList.add('login-theme');
        }
        // Add more route checks if needed
      }
    });
  }
  

  getRouteClass() {
    const url = this.router.url;
    if (url.includes('ocr-Master')) {
      return 'p-x0';
    } 
   
  }
  
  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
